import { AxiosPromise } from 'axios';
import { urlsConfig } from 'src/configs';
import { urlHelper } from 'src/app/helpers';
import { axios, axiosc } from 'src/app/utils';
import { queryTypes, servicesEtmenSiniflariTypes } from 'src/types';

export const etmenSiniflariLookup = ({
  limit,
  load,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
}: servicesEtmenSiniflariTypes.EtmenSiniflariLookupDataType): AxiosPromise<servicesEtmenSiniflariTypes.EtmenSiniflariLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  if (load) {
    query.load = load.join(',');
  }

  return axiosc.get(urlHelper.addQueryParameters(query, urlsConfig.generics.common.etmenSiniflari), {
    blockSpinner,
  });
};
